import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'
import { getStore } from '../utils/tools.js'

Vue.use(Vuex)
const state = {
    userInfo: {
        user_id: 0,
        gender: 0,
        is_admin: 0,
        last_login_ip: "",
        last_login_type: "",
        last_login_time: "",
        status: 0,
        email: "",
        birthday: "",
        avatar: "",
        dingding_unionid: "",
        mobile: "",
        realname: "",
        role_ids: "",
        roles: "",
        auth_ids: [],
        auth_points: []
    },
    demo: [],
    editorBases: [],
    curAction: '',
    curMenuPath: '',
    // 权限列表
    roleList: {
        list: [
        ],
        page: {
            per_page: 15,
            current: 1,
            total_page: 1
        }
    },
    authPoints: [],
    authUser: {
        list: []
    },
    dataChannels: {
        page: {
            per_page: 15,
            current: 1,
            total_page: 1
        },
        list: [
            // {
            //     realname: 'channel1',
            //     name: 'channel1',
            // },
            // {
            //     realname: 'channel2',
            //     name: 'channel2',
            // },
            // {
            //     realname: 'channel3',
            //     name: 'channel3',
            // },
        ]
    },
    dataChannelGroups: {
        list: [
            // {
            //     name: 'sw',
            //     group_name: '商务',
            //     reg: 'sw'
            // },
            // {
            //     name: 'bd',
            //     group_name: '百度',
            //     reg: 'bd'
            // },
            // {
            //     name: '360',
            //     group_name: '360',
            //     reg: '360'
            // }
        ]
    },
    fieldsSuite: [],
    envirVersion: '' // 环境版本，tw台湾，usa美国
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js